module.exports = __webpack_public_path__ + "img/22.121b3d6f.gif";